import { render, staticRenderFns } from "./EditShareDialog.vue?vue&type=template&id=7fff4a60&scoped=true"
import script from "./EditShareDialog.vue?vue&type=script&lang=ts"
export * from "./EditShareDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fff4a60",
  null
  
)

export default component.exports